export const AgreementContent = {
  title: "Terms of Use",
  content: [
    {
      h: "Enrolling in Chowbus Cash Back Program",
      p: [
        "Enrollment is tied to a given restaurant location.",
        "Diner may enroll with multiple restaurants.",
        `Diner consents to receiving communications via email, SMS, push notifications, and/or phone calls regarding the Chowbus cash back program and/or marketing communications related to the restaurant(s) they are enrolled with.`,
      ],
    },
    {
      h: `Accruing Chowbus Cash Back`,
      p: [
        `Chowbus cash back credit is earned on the post-discount subtotal portion of the bill that is paid by cash, credit, and/or debit. It is not earned on tax or tip paid, and it is not earned on any post-discount subtotal portion paid by Chowbus cash back credit.`,
        `For the purposes of calculating the portion of the bill that is eligible to earn Chowbus cash back credits on, Chowbus may take the bill total (post-discount subtotal + service charges + tax) specified by the restaurant, estimate the tax amount given a base tax rate setup by the restaurant and Chowbus, and subtract this estimated tax amount from the bill total specified by the restaurant.`,
        `Chowbus cash back credit may be saved and accrued over multiple payments to the restaurant.`,
        `Chowbus cash back credit accrued on an order may not be applied towards the bill of the order in which it was accrued. It may only be applied to future orders.`,
      ],
    },
    {
      h: `Using Chowbus Cash Back`,
      p: [
        `If Chowbus cash back credit is less than the post-discount subtotal portion of the bill, a diner electing to apply Chowbus cash back to the bill will have the entirety of their Chowbus cash back credit applied to the bill and additional payment methods must be rendered.`,
        `If Chowbus cash back credit is greater than or equal to the final payment total (post-discount subtotal + service charges + tax + tip), a diner electing to apply Chowbus cash back to the bill will have the final payment total deducted from their Chowbus cash back credit.`,
        `Chowbus cash back credit may not be used for another party’s order.`,
        `Chowbus cash back accrued for a given restaurant location may only be applied to an order at that specific restaurant location. It may not be used at any other restaurant or branch or the same restaurant.`,
        `Diner may not specify a specific amount of Chowbus cash back to apply to the bill.`,
      ],
    },
    {
      h: `Additional Terms`,
      p: [
        `Chowbus cash back credit may not be transferred to another diner or restaurant.`,
        `If a restaurant exits the Chowbus cash back program for any reason, any outstanding Chowbus cash back credits a diner may have for this restaurant are forfeited. Diners will receive notice within 30 days of the restaurant’s final day of participation.`,
        `Chowbus cash back credit expires 12 months after the date of issue.`,
      ],
    },
  ],
};
